import * as SignersAPI from "../../API/signers.api.js";
import SignerTypes from "../../models/signerTypes.js";

export default class Signers {
	constructor(API) {
		this.modules = {
			API
		};
	}
	state() {
		return {
			signers: [],
			signerTypes: [],
			isUpdatingSigners: false
		};
	}
	namespaced = true
	getters = {
		principalSigners: state => state.signers.filter(s => s.notarizationSignerTypeId === SignerTypes.PRINCIPAL),
		witnesses: state => state.signers.filter(s => s.notarizationSignerTypeId === SignerTypes.WITNESS),
		lockedOutSigners: (_, getters) => getters.principalSigners.filter(ps => ps.isLockedOut),
		principalSignersCount: (_, getters) => getters.principalSigners.length
	}
	mutations = {
		signers(state, signers) {
			state.isUpdatingSigners = false;
			state.signers = signers;
		},
		signersTypes(state, signerTypes) {
			state.signerTypes = signerTypes;
		},
		setIsUpdatingSigners(state, value) {
			state.isUpdatingSigners = value;
		},
	}
	actions = {
		loadSigners({ dispatch, state, commit }) {
			commit(`setIsUpdatingSigners`, true);
			return dispatch(`API/load`, { apiPromise: SignersAPI.signers(state.API.notarizationId), successMutation: `Signers/signers` });
		},
		loadSignerTypes({ dispatch }) {
			return dispatch(`API/load`, { apiPromise: SignersAPI.signerTypes(), successMutation: `Signers/signersTypes` });
		}
	}
}
